const BusinessIcon = () => {
  return (
    <svg
      width="23"
      height="25"
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9154 5.26379H17.5731V4.11488C17.5731 2.24225 16.0496 0.71875 14.1769 0.71875H9.50406C7.63143 0.71875 6.10793 2.24225 6.10793 4.11488V5.26379H3.7656C2.06347 5.26379 0.683594 6.64367 0.683594 8.3458V12.2219H22.9973V8.3458C22.9974 6.6436 21.6175 5.26379 19.9154 5.26379ZM15.1075 5.26379H8.5736V4.11488C8.5736 3.60178 8.99096 3.18436 9.50412 3.18436H14.177C14.6901 3.18436 15.1075 3.60178 15.1075 4.11488L15.1075 5.26379Z"
        fill="#181717"
      />
      <path
        d="M19.9564 15.7777C19.9564 16.1737 19.6354 16.4947 19.2394 16.4947H16.6873C16.2913 16.4947 15.9704 16.1737 15.9704 15.7777V14.5016H7.71057V15.7777C7.71057 16.1737 7.38961 16.4947 6.99364 16.4947H4.44136C4.04551 16.4947 3.72455 16.1737 3.72455 15.7777V14.5016H0.683594V21.2576C0.683594 22.9597 2.06347 24.3396 3.7656 24.3396H19.9153C21.6175 24.3396 22.9973 22.9597 22.9973 21.2576V14.5016H19.9564V15.7777Z"
        fill="#181717"
      />
    </svg>
  );
};

export default BusinessIcon;
